/**=========================================================
 * Module: user.js
 * User Controller
 =========================================================*/

App.controller('UserController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$filter', 'toaster', '$http', 'ngDialog',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter, toaster, $http, ngDialog) {
    "use strict";

    $scope.type = 'account';
    $scope.id = $state.params.filter;
    $scope.action = $state.params.action;

    $scope.model = {};
    $scope.error = {};
    $scope.page = {
        title: '',
        subTitle: ''
    };

    $scope.pop = function(type, title, text) {
        toaster.pop(type, title, text, 0, 'trustedHtml');
    };

    $scope.initialized = false;
    $scope.watchActivated = false;
    $scope.init = function(){

    	if($rootScope.user.id){
            $scope.initialized = true;



		    $scope.loadFiles = function(){
		        
		    };

			$scope.customRoleSelect = [
				{ name: '', label: '-'},
				{ name: 'TM_MANAGER', label: $filter('translate')('enums.customRole.TM_MANAGER')},
				{ name: 'REVIEWER', label: $filter('translate')('enums.customRole.REVIEWER')}
			]

		    if($scope.action=='create' && $rootScope.user.admin){
				$scope.page.title = 'labels.ADDNEWUSER'
				$scope.page.subTitle = $scope.id.toUpperCase()
		    		    D.load('account', 'group='+$scope.id, { cache:false }).then(
		    		    
		    		                function(model){
		    		                    $scope.model = model;
		    		                    $scope.model.group=$scope.id;
		    		                    $scope.model.dateFormat = 'DD_MM_YYYY_SL';
		    		                    //$scope.page.title = labels.CREATEUSER;
		    		                    //$scope.page.subTitle = labels.CREATEUSER;
		    		                    $scope.form = {
		    		            		        title: 'labels.ADDNEWUSER',
		    		            		        status: '',
		    		            		        type: 'account',
		    		            		        model: $scope.model,
		    		            		        fields: [
                                                    {
		    		            		                available: true,
		    		            		                type: 'text',
		    		            		                name: 'name',
		    		            		                required: true
		    		            		            },{
		    		            		                available: true,
		    		            		                type: 'text',
		    		            		                name: 'username',
		    		            		                required: true
		    		            		            },{
		    		            		                available: true,
		    		            		                type: 'email',
		    		            		                name: 'email',
		    		            		                required: true
		    		            		            },{
		    		            		                available: true,
		    		            		                type: 'text',
		    		            		                name: 'phone'
		    		            		            },{
		    		            		                available: true,
		    		            		                type: 'text',
		    		            		                name: 'mobile'
		    		            		            },{
		    		            		                available: true,
		    		            		                type: 'textarea',
		    		            		                name: 'notes'
		    		            		            },{
		    		            		                available: true,
		    		            		                type: 'checkbox',
		    		            		                name: 'superUser',
		    		            		                label: 'fields.SUPERUSER'
		    		            		            },{
														available: true,
														type: 'select',
														data: $scope.customRoleSelect,
														valueField: 'name',
														labelField: 'label',
														name: 'customRole',
														placeholder: 'labels.OPTIONALCUSTOMROLE',
														onchange: function(){
															var viewReviewLanguageField = false
															if($scope.form.model.customRole=='REVIEWER'){ viewReviewLanguageField = true }
															$scope.form.fields.forEach(function(f){
																if(f.name=='reviewLanguage') f.available = viewReviewLanguageField
																if(f.name=='isDefaultReviewer') f.available = viewReviewLanguageField
															})
														}
													},{
														available: $scope.model.customRole=='REVIEWER',
														type: 'language',
														name: 'reviewLanguage',
														placeholder: 'labels.SELECTLANGUAGE'
													},{
														available: $scope.model.customRole=='REVIEWER',
														type: 'checkbox',
														name: 'isDefaultReviewer'
													},{
		    		            		                available: true,
		    		            		                type: 'radio',
		    		            		                name: 'language',
		    		            		                label: 'fields.LANGUAGE',
		    		            		                options: [{
		    		            		                    value: 'it_IT',
		    		            		                    label: 'enums.language.it_IT'
		    		            		                },{
		    		            		                    value: 'en_GB',
		    		            		                    label: 'enums.language.en_GB'
		    		            		                },{
		    		            		                    value: 'de_DE',
		    		            		                    label: 'enums.language.de_DE'
		    		            		                }]
		    		            		            },{
		    		            		                available: true,
		    		            		                type: 'radio',
		    		            		                name: 'numberFormat',
		    		            		                label: 'fields.NUMBERFORMAT',
		    		            		                options: [{
		    		            		                    value: 'DOT_COMMA',
		    		            		                    label: 'enums.numberFormat.DOT_COMMA'
		    		            		                },{
		    		            		                    value: 'COMMA_DOT',
		    		            		                    label: 'enums.numberFormat.COMMA_DOT'
		    		            		                }]
		    		            		            },{
		    		            		                available: true,
		    		            		                type: 'radio',
		    		            		                name: 'dateFormat',
		    		            		                label: 'fields.DATEFORMAT',
		    		            		                options: [{
		    		            		                    value: 'DD_MM_YYYY_SL',
		    		            		                    label: $filter('display')(new Date().getTime(),{type:'date',format:'DD/MM/YYYY'})
		    		            		                    	+ ' (' + $filter('translate')('enums.dateFormat.DD_MM_YYYY_SL') + ')'
		    		            		                },{
		    		            		                    value: 'MM_DD_YYYY_SL',
		    		            		                    label: $filter('display')(new Date().getTime(),{type:'date',format:'MM/DD/YYYY'})
	    		            		                    		+ ' (' + $filter('translate')('enums.dateFormat.MM_DD_YYYY_SL') + ')'
		    		            		                },{
		    		            		                    value: 'YYYY_MM_DD_DA',
		    		            		                    label: $filter('display')(new Date().getTime(),{type:'date',format:'YYYY-MM-DD'})
	    		            		                    		+ ' (' + $filter('translate')('enums.dateFormat.YYYY_MM_DD_DA') + ')'
		    		            		                }]
		    		            		            },{
														available: true,
														type: 'radio',
														name: 'csvSep',
														options: [{
															value: ',',
															label: ','
														},{
															value: ';',
															label: ';'
														}]
													},{
		    		            		                available: true,
		    		            		                type: 'separator'
		    		            		            },{
		    		            		                available: true,
		    		            		                type: 'submit',
		    		            		                name: 'empty',
		    		            		                value: 'fields.SUBMIT'
		    		            		            }
		    		            		        ],
		    		            		        validate: function(){
	                                              	var errors = [];
	                                              	for(var j=0; j<this.fields.length; j++){
	                                        			var field = this.fields[j];
	                                        			if(field.required && !this.model[field.name]){
	                                        				errors.push({field:field,error:'required'});
	                                        			}
	                                        			if(field.name=='email'){
	                                        				var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	                                        			    if(!re.test(this.model['email']))
	                                        			    	errors.push({field:field,error:'invalid'});
	                                        			}
	                                        		}


	                                              	if(errors.length) {
	                                              		var errorMessages ="<ul>";
	                                              		for(var i=0; i<errors.length; i++){
	                                              			var e = errors[i];
	                                              			errorMessages += "<li>"
	                                              				+$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
	                                              				+"</li>";
	                                              		}
	                                              		errorMessages += "</ul>";
	                                              		$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
	                                              		return false;
	                                              	}
	                                              	else return true;
	                                              },
		    		            		        submit: function(){
		    		            		        	if(this.validate()){
			    		            		            $scope.form.status = 'submitting';
			    		            		            D.save($scope.type, $scope.model).then(
			    		            		                function(response){
			    		            		                    $scope.form.status = 'submitted';
			    		            		                    $state.go('app.entity',{
			    		            		                    	action: 'view',
			    		            		                    	type: 'group',
			    		            		                    	filter: $scope.id
			    		            		                    })
			    		            		                }
			    		            		                
			    		            		            ).catch(function(response){
			    		            		                    $scope.form.status = 'error';
			    		            		                    if(response.data && response.data.exc=='InvalidValueException'){
			    		            		                    	if(response.data.msg.indexOf('username')===0)
			    		            		                    		$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), $filter('translate')('labels.USERNAMEEXISTS'));
			    		            		                    	else if(response.data.msg.indexOf('email')===0)
			    		            		                    		$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), $filter('translate')('labels.EMAILEXISTS'));

			    		            		                    }
			    		            		                });
		    		            		        	}
		    		            		        }
		    		            		    };
		    		                    $scope.form.model = $scope.model;
		    		                    $scope.loadFiles();
		    		                }
		    		                
		    		            ).catch(function(error){
		    		                    $scope.error = error;
		    		                });

		    }else if($scope.action=='password'){
				
				//$scope.id=$scope.id.substring(0,$scope.id.indexOf("&password"))
				$scope.checkPwdTimeouts = {};
				$scope.pwdStrength = { };
				var getLabel = function(lbl){
					return $filter('translate')('zxcvbn.'+lbl.replace(/\./g,'').replace(/,/g,'').replace(/'/g,'').replace(/-/g,'').replace(/"/g,'').replace(/ /g, '').toUpperCase())
				}
				$scope.checkPwd = function(fieldname){
					if($scope.checkPwdTimeouts[fieldname]){
						$timeout.cancel($scope.checkPwdTimeouts[fieldname]);
					}
					$scope.checkPwdTimeouts[fieldname] = $timeout(function(){
						$scope.checkingValue = $scope.model[fieldname]
            			var checkingValue = $scope.model[fieldname]
						D.call('zxcvbn', 'post', null, { pwd: $scope.model[fieldname] })
						 .then(function(response){
							if(checkingValue!=$scope.checkingValue) return
							var f = {};
							for(var i in $scope.form.fields){
								if($scope.form.fields[i].name==fieldname){
									f = $scope.form.fields[i];
								}
							}
							var cls = '';
							if(response.score<=1) cls = 'alert-danger';
							if(response.score == 2) cls = 'alert-warning';
							var text = '';
							if(response.score > 2) {
								cls = 'alert-success';
								text = getLabel('PASSWORDISGOOD')
								if(response.score==4) text = getLabel('PASSWORDISVERYGOOD');
								$scope.form.status = 'submittable';
							} else {
								$scope.form.status = 'notsubmittable';
							}
							if(response.feedback.warning){
								text += getLabel(response.feedback.warning) + '. ';
							} 
							if(response.feedback.suggestions){
								if(typeof response.feedback.suggestions == 'string'){
									text += getLabel(response.feedback.suggestions) + '.';
								} else {
									text += response.feedback.suggestions.map(function(l){ return getLabel(l);}).join('. ');
								}
							}
							f.pwdStrength = {
								show: true,
								cls: cls,
								text: text.replace('..','.')
							}
						})
					}, 300);
				}
		    	D.load($scope.type, $scope.id).then(
                		function(model){
							$scope.model = model;
							if($scope.model.pwdS!=null && $scope.model.pwdS<=2){
								$scope.popupMessage = 'labels.WEAKPWD';
								ngDialog.open({
									template: '/app/views/entities/popup.html',
									className: 'ngdialog-theme-default',
									scope: $scope,
									cache: false
								  });
							}
                			$scope.page.title = model.name;
                			$scope.page.subTitle = model.group.name;
                			$scope.form = {
                					title: 'labels.CHANGEPASSWORD',
                					status: '',
                					type: 'account',
                					model: $scope.model,
                					fields: [
                					         {
                					        	 available: true,
                					        	 type: 'password',
                					        	 name: 'password',
                					        	 required: true
                					         },{
                					        	 available: true,
                					        	 type: 'password',
												 name: 'newPassword',
												 onchange: $scope.checkPwd,
                					        	 required: true
                					         },{
                					        	 available: true,
                					        	 type: 'password',
                					        	 name: 'repeatNewPassword',
                					        	 required: true
                					         },{
                					        	 available: true,
                					        	 type: 'separator'
                					         },{
                					        	 available: true,
                					        	 type: 'submit',
                					        	 name: 'empty',
                					        	 value: 'fields.SUBMIT'
                					         }
                					         ],
                                             validate: function(){
                                              	var errors = [];
                                              	for(var j=0; j<this.fields.length; j++){
                                        			var field = this.fields[j];
                                        			if(field.name=='newPassword'){
                                        				if($('[name=newPassword]').val()!=$('[name=repeatNewPassword]').val()){
                                        					errors.push({field:field,error:'newpassword'});
                                                      	}
                                        				if(this.model['newPassword'].length<8){
                                        					errors.push({field:field,error:'passwordtooshort'});
                                        				}
                                        			}
                                        		}


                                              	if(errors.length) {
                                              		var errorMessages ="<ul>";
                                              		for(var i=0; i<errors.length; i++){
                                              			var e = errors[i];
                                              			errorMessages += "<li>"
                                              				+$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase())
                                              				+"</li>";
                                              		}
                                              		errorMessages += "</ul>";
                                              		$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                              		return false;
                                              	}
                                              	else return true;
                                              },
                					         submit: function(){
                					        	 if(this.validate()){
	                					        	 $scope.form.status = 'submitting';
	                					        	 D.save($scope.type, $scope.model).then(
	                					        			 function(response){
																 $scope.form.status = 'submitted';
																 $state.go('app.dashboard', {});
                                
	                					        			 }
	                					        			 
	                					        	 ).catch(function(response){
	                					        				 $scope.form.status = 'error';
	                					        			 });
                					        	 }
                					         }
                			};
                			$scope.form.model = $scope.model;
                			$scope.loadFiles();
                		}
                		
                ).catch(function(error){
                			$scope.error = error;
                		});
		    } else{
				D.load($scope.type, $scope.id).then(
					function (model) {

						var listenFB = function(){
								FIREBASE.listen('Account', $scope.id, function(value){
								if(value && FIREBASE.isAfter(value.timestamp,model.T)){
									$scope.popupMessage = 'labels.USERCHANGED';
									$scope.refreshFunction = function(){
										window.location.reload();
									}
									ngDialog.open({
										template: '/app/views/entities/popup-refresh.html',
										className: 'ngdialog-theme-default',
										scope: $scope,
										cache: false
									});
								}
							}, null, { interval: 60000 });
						}
						//listenFB();

						$scope.model = model;
						var promise = $rootScope.user.admin ? 
							D.query('group', 'supergroup=' + $scope.model.group.supergroup, { cache: false }) : 
							new Promise(function(resolve,reject){
								 resolve([]);
							})
						promise.then(function(groups) {
							if($rootScope.user.admin){
								for(var i=0; i<groups.length; i++){
									if(groups[i].id==$scope.model.oGroup){
										groups[i].readonly = true;
									}	
								}
								
								$scope.groupsOfSupergroup = groups;
								
								if($scope.model.sgGroups===null){
									$scope.model.sgGroups = $scope.groupsOfSupergroup.map(function(g){ return g.id;})
								}
								if($scope.model.sgUser){
									$scope.model.sgAs = {}
									for(let sgg of $scope.model.sgGroups){
										if($scope.model.notSupOf && $scope.model.notSupOf.indexOf(sgg)>=0){
											$scope.model.sgAs[sgg] = 'USER'
										} else {
											$scope.model.sgAs[sgg] = 'SUPERUSER'
										}
									}
								}
							}
							D.query('account', 'group=' + $scope.model.group.id + '&_withSGUsers=true', { cache: false }).then(function (response) {
									$scope.superusers = [{
										id: '',
										name: '-'
									}];
									for (var i = 0; i < response.length; i++) {
										if (response[i].superUser && response[i].id!=$scope.model.id) {
											$scope.superusers.push(response[i]);
										}
									}
									$scope.model.memories = model.opts.memories;
									$scope.model.writememories = model.opts.writememories;
									$scope.model.canacceptoffers = model.opts.canacceptoffers;
									$scope.model.acceptingsuperuser = model.opts.acceptingsuperuser;
									$scope.model.nomessagetoother = model.opts.nomessagetoother
									$scope.model.reviewLanguage = model.opts.reviewLanguage
									$scope.model.isDefaultReviewer = model.opts.isDefaultReviewer
									$scope.model.dashboardfilter = model.opts.dashboardfilter
									$scope.model.gdprcheckdate = model.opts.gdprcheckdate
									$scope.page.title = model.name;
									$scope.page.subTitle = model.group.name;
									$scope.form = {
										title: 'labels.EDITUSER',
										status: '',
										type: 'account',
										model: $scope.model,
										fields: [{
											available: $rootScope.user.role == 'ADMIN' || $rootScope.user.role == 'SUPERADMIN',
											type: 'checkbox',
											name: 'enabled'
										}, {
											available: true,
											type: 'static',
											name: 'username'
										}, {
											available: true,
											type: 'text',
											name: 'name',
											required: true
										}, {
											available: true,
											type: 'email',
											name: 'email',
											required: true
										}, {
											available: $rootScope.user.admin,
											type: 'text',
											name: 'phone'
										}, {
											available: $rootScope.user.admin,
											type: 'text',
											name: 'mobile'
										}, {
											available: $rootScope.user.admin,
											type: 'textarea',
											name: 'notes'
										}, {
											available: false,
											type: 'picture',
											name: 'picture',
											required: true
										}, {
											label: 'fields.PICTURE',
											uploadLabel: 'fields.UPLOADPICTURE',
											available: true,
											type: 'pictureFile',
											name: 'upload',
											limit: 1,
											canUpload: true,
											allow: 'jpg|jpeg|png',
											srcField: 'picture',
											public: true,
											bucket: $rootScope.bucketName($scope.model.groupType=='ADMIN' ? null : $scope.model.group.id)
										}, {
											available: $rootScope.user.role == 'ADMIN' || $rootScope.user.role == 'SUPERADMIN',
											type: 'checkbox',
											name: 'superUser',
											label: 'fields.SUPERUSER'
										}, {
											available: $scope.model.group.supergroup && $scope.model.role == 'SUPERUSER' && ($rootScope.user.role == 'ADMIN' || $rootScope.user.role == 'SUPERADMIN'),
											type: 'checkbox',
											name: 'sgUser',
											label: 'fields.SUPERGROUPUSER',
											onchange: function(){
												$scope.form.fields.filter(function(f){
													return f.name=='sgGroups';
												})[0].available = $scope.model.sgUser
											}
										}, {
											available: ($rootScope.user.role == 'ADMIN' || $rootScope.user.role == 'SUPERADMIN') && $scope.model.sgUser,
											type: 'checkboxesSG',
											name: 'sgGroups',
											data: $scope.groupsOfSupergroup,
											valueField: 'id',
											labelField: 'name',
											hideSelectUnselectAll: true
										},{
											available: $rootScope.user.role == 'ADMIN' || $rootScope.user.role == 'SUPERADMIN',
											type: 'select',
											data: $scope.customRoleSelect,
											valueField: 'name',
											labelField: 'label',
											name: 'customRole',
											placeholder: 'labels.OPTIONALCUSTOMROLE',
											onchange: function(){
												var viewReviewLanguageField = false
												if($scope.form.model.customRole=='REVIEWER'){ viewReviewLanguageField = true }
												$scope.form.fields.forEach(function(f){
													if(f.name=='reviewLanguage') f.available = viewReviewLanguageField
													if(f.name=='isDefaultReviewer') f.available = viewReviewLanguageField
												})
											}
										},{
											available: $scope.model.customRole=='REVIEWER' && ($rootScope.user.role == 'ADMIN' || $rootScope.user.role == 'SUPERADMIN'),
											type: 'select',
											data: $rootScope.languages,
											valueField: 'code',
											labelField: 'name',
											name: 'reviewLanguage',
											placeholder: 'labels.SELECTLANGUAGE'
										},{
											available: $scope.model.customRole=='REVIEWER' && ($rootScope.user.role == 'ADMIN' || $rootScope.user.role == 'SUPERADMIN'),
											type: 'checkbox',
											name: 'isDefaultReviewer'
										},{
											available: $rootScope.user.role == 'ADMIN' || $rootScope.user.role == 'SUPERADMIN',
											type: 'checkbox',
											name: 'memories'
										}, {
											available: $rootScope.user.role == 'ADMIN' || $rootScope.user.role == 'SUPERADMIN',
											type: 'checkbox',
											name: 'writememories'
										}, {
											available: $rootScope.user.role == 'ADMIN' || $rootScope.user.role == 'SUPERADMIN',
											type: 'checkbox',
											name: 'canacceptoffers', 
											onchange: function(){
												$scope.form.fields.filter(function(f){
													return f.name=='acceptingsuperuser';
												})[0].available = ($rootScope.user.role == 'ADMIN' || $rootScope.user.role == 'SUPERADMIN') && !$scope.model.canacceptoffers;
											}
										}, {
											available: ($rootScope.user.role == 'ADMIN' || $rootScope.user.role == 'SUPERADMIN') && !$scope.model.canacceptoffers,
											type: 'select',
											data: $scope.superusers,
											name: 'acceptingsuperuser',
											valueField: 'id',
											labelField: 'name',
											placeholder: ' ',
											required: true
										}, {
											available: ($rootScope.user.role == 'ADMIN' || $rootScope.user.role == 'SUPERADMIN') && $scope.model.groupType=='CLIENT' && $scope.model.superUser,
											type: 'select',
											data: [{value:'own',label:$filter('translate')('labels.VIEWOWNCLIENT')},{value:'all',label:$filter('translate')('labels.VIEWALL')}],
											name: 'dashboardfilter',
											valueField: 'value',
											labelField: 'label',
											required: true
										},{
											available: $scope.model.groupType=='CLIENT',
											type: 'checkbox',
											name: 'nomessagetoother'
										}, {
											available: true,
											type: 'radio',
											name: 'language',
											label: 'fields.LANGUAGE',
											options: [{
												value: 'it_IT',
												label: 'enums.language.it_IT'
											}, {
												value: 'en_GB',
												label: 'enums.language.en_GB'
											}, {
												value: 'de_DE',
												label: 'enums.language.de_DE'
											}]
										}, {
											available: true,
											type: 'radio',
											name: 'numberFormat',
											label: 'fields.NUMBERFORMAT',
											options: [{
												value: 'DOT_COMMA',
												label: 'enums.numberFormat.DOT_COMMA'
											}, {
												value: 'COMMA_DOT',
												label: 'enums.numberFormat.COMMA_DOT'
											}]
										}, {
											available: true,
											type: 'radio',
											name: 'dateFormat',
											label: 'fields.DATEFORMAT',
											options: [{
												value: 'DD/MM/YYYY',
												label: $filter('display')(new Date().getTime(), {
														type: 'date',
														format: 'DD/MM/YYYY'
													}) +
													' (' + $filter('translate')('enums.dateFormat.DD_MM_YYYY_SL') + ')'
											}, {
												value: 'MM/DD/YYYY',
												label: $filter('display')(new Date().getTime(), {
														type: 'date',
														format: 'MM/DD/YYYY'
													}) +
													' (' + $filter('translate')('enums.dateFormat.MM_DD_YYYY_SL') + ')'
											}, {
												value: 'YYYY-MM-DD',
												label: $filter('display')(new Date().getTime(), {
														type: 'date',
														format: 'YYYY-MM-DD'
													}) +
													' (' + $filter('translate')('enums.dateFormat.YYYY_MM_DD_DA') + ')'
											}]
										}, {
											available: true,
											type: 'radio',
											name: 'csvSep',
											options: [{
												value: ',',
												label: ','
											}, {
												value: ';',
												label: ';'
											}]
										}, {
											available: $scope.model.groupType=='CLIENT' || $scope.model.groupType=='SUPPLIER',
											type: 'static',
											name: 'gdprcheckdate',
											displayType: 'date',
											format: 'L HH:mm:ss'
										},{
											available: true,
											type: 'separator'
										}, {
											available: true,
											type: 'submit',
											name: 'empty',
											value: 'fields.SUBMIT'
										}],
										validate: function(){
											var errors = [];
											for(var i=0; i<this.fields.length; i++){
													var field = this.fields[i];
													if(field.available && field.required && !this.model[field.name]){
														errors.push({field:field,error:'required'});
													}

											}
											if(errors.length) {
												var errorMessages ="<ul>";
												for(var i=0; i<errors.length; i++){
													var e = errors[i];
													errorMessages += "<li>"
														+$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
														+"</li>";
												}
												errorMessages += "</ul>";
												$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
												return false;
											}
											else return true;
										},
										submit: function () {
											if(this.validate()){
												$scope.form.status = 'submitting';
												D.save($scope.type, $scope.model).then(
													function (response) {
														$scope.model = response;
														model = response
														$scope.form.status = 'submitted';
														listenFB();
													}
													
												).catch(function (response) {
														$scope.form.status = 'error';
														if (response.data && response.data.exc == 'InvalidValueException') {
															if (response.data.msg.indexOf('username') === 0)
																$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), $filter('translate')('labels.USERNAMEEXISTS'));
															else if (response.data.msg.indexOf('email') === 0)
																$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), $filter('translate')('labels.EMAILEXISTS'));
															else if (response.data.msg.indexOf('enabled') === 0)
																$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), $filter('translate')('labels.PROJECTSOWNED'));
														}
													});
											}
										}
									};
									$scope.form.model = $scope.model;
									$scope.loadFiles();
								}
								
							).catch(function (error) {
									$scope.error = error;
								});
						}).catch(console.error);
					}).catch(console.error);
					
					$scope.imp = function(){
						R.one('session','mine').customPUT({imp:$scope.id}).then(function(response){
							FIREBASE.auth(response.jwt, function(){
								$window.location.reload();
							  })
						});
					}

		    }
    	} else {
            if(!$scope.watchActivated){
                $scope.watchActivated = true;
                $rootScope.$watch('user.id', function(){
                    if(!$scope.initialized){
                        $scope.init();
                    }
                });
            }
        }
    }

    $scope.init();
  }
  ]);
